// extracted by css-extract-rspack-plugin
export default {"colorGray9":"#dddddd","separator":"index__separator___fbx8K"};